/* import __COLOCATED_TEMPLATE__ from './create-salesforce-case.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();